import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Signed POS agreements live in the private pos-documents bucket: they hold the
 * client's contact details. The row stores the storage path, and a screen opens
 * it through a short-lived signed link, never a public URL.
 */
export async function signPosDocument(supabase: SupabaseClient, path: string): Promise<string | null> {
  const { data, error } = await supabase.storage.from('pos-documents').createSignedUrl(path, 3600);
  if (error || !data?.signedUrl) return null;
  return data.signedUrl;
}
